export const getClassNameLocalLogLinkText = (idLogType: number): string => {
    switch (true) {
        case idLogType === -11:
        case idLogType === -6:
        case idLogType === -5:
        case idLogType === -4:
        case idLogType === -3:
        case idLogType === -2:
        case idLogType === -1:
        case (idLogType >= 1 && idLogType <= 10):
            return 'link-color-orange'
        case (idLogType >= 21 && idLogType <= 40):
            return 'link-color-red';
        default:
            return '';
    }
}